import { ItemList } from '../../orm'

class AdminFaxCostStructureList extends ItemList {
    getEntityKey() {
        return "admin/fax_cost_structure"
    }
}

export const adminFaxCostStructureList = new AdminFaxCostStructureList("admin_fax_cost_structure__default")
